import {useState} from "react";
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import ButtonGroup from '@mui/material/ButtonGroup';
import CustomDialog from "../Dialog/DiaCompMedium";
import { useTheme } from "@mui/material";

export default function SectionButtonGroup(props) {

const theme = useTheme();

const {button_1, button_2, button_3, title_dialog_1, content_dialog_1, title_dialog_2, content_dialog_2, to} = props

const [dialogOpen1, setdialogOpen1] = useState(false);
const handleDialogOpen1 = () => {setdialogOpen1(true);};
const handleDialogClose1 = () => {setdialogOpen1(false);};

const [dialogOpen2, setdialogOpen2] = useState(false);
const handleDialogOpen2 = () => {setdialogOpen2(true);};
const handleDialogClose2 = () => {setdialogOpen2(false);};

return(
<>      

{theme.palette.mode === "light" ? (

<Box sx={{p:1, mb:2}}>
      <ButtonGroup orientation="vertical" variant="text" size="small" color="quartiary">
                <Button onClick={handleDialogOpen1}  sx={{ color: 'common.black', fontWeight: 400, '&:hover': {color: 'greydark.C900', borderRadius: '20x', transform: 'scale(1.2)',}  }}> {button_1} </Button>
                <Button onClick={handleDialogOpen2}  sx={{ color: 'common.black', fontWeight: 400, '&:hover': {color: 'greydark.C900', borderRadius: '20x', transform: 'scale(1.2)',} }}>{button_2} </Button>  
                <Button component={RouterLink} to={to} sx={{ color: 'common.black', fontWeight: 400, '&:hover': {color: 'greydark.C900', borderRadius: '20x', transform: 'scale(1.2)',} }}>{button_3} </Button>  
      </ButtonGroup>
</Box>

):(

      <Box sx={{p:1, mb:2}}>
      <ButtonGroup orientation="vertical" variant="text" size="small" color="secondary">
                <Button onClick={handleDialogOpen1}  sx={{ color: 'common.white', fontWeight: 400, '&:hover': {color: 'common.white', bgcolor: 'secondarydark.C400', transform: 'scale(1.2)',}  }}> {button_1} </Button>
                <Button onClick={handleDialogOpen2}  sx={{ color: 'common.white', fontWeight: 400, '&:hover': {color: 'common.white', bgcolor: 'secondarydark.C400', transform: 'scale(1.2)',} }}>{button_2} </Button>  
                <Button component={RouterLink} to={to} sx={{ color: 'common.white', fontWeight: 400, '&:hover': {color: 'common.white', bgcolor: 'secondarydark.C400', transform: 'scale(1.2)',} }}>{button_3} </Button>  
      </ButtonGroup>
</Box>

)}

{/* Dialog 1 */}
                       
       
           <CustomDialog open={dialogOpen1} onClose={handleDialogClose1}
       
                  title={title_dialog_1}
                  
                  content = {content_dialog_1}
       
               />

{/* Dialog 2 */}


      <CustomDialog open={dialogOpen2} onClose={handleDialogClose2}
            
            title={title_dialog_2}
            
            content = {content_dialog_2}

     />

</>
)}